import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "UI/UX Foundations & Design Thinking Principles",
    description:
      "Difference between UI & UX explained, Human-centered design processes, Design thinking stages: Empathize → Define → Ideate → Prototype → Test, Understanding product goals user pain points & journeys, Real-world examples of good vs bad UX",
  },
  {
    title: "User Research, Personas & User Journey Mapping",
    description:
      "Conducting interviews surveys & usability research, Creating user personas & demographic profiles, Mapping user journeys & identifying touchpoints, Understanding user emotions and behaviors, Turning insights into actionable design decisions",
  },
  {
    title: "Wireframing, Sketching & Low-Fidelity Prototyping",
    description:
      "Paper sketching & rapid idea exploration, Wireframe creation for web & app interfaces, Layout structures & information hierarchy, Low-fidelity prototypes for quick validation, Tools: Figma Balsamiq Adobe XD",
  },
  {
    title: "Visual Design, Color Theory & Branding Fundamentals",
    description:
      "Principles: contrast alignment spacing balance, Color theory: palettes gradients visual moods, Typography: font pairing readability & hierarchy, Grids spacing & alignment rules, Creating consistent brand-based UI systems",
  },
  {
    title: "High-Fidelity UI Design & Component Systems",
    description:
      "Designing polished screens & interactive UIs, Buttons cards forms navbars & design components, Style guides & design systems, Atomic design methodology, Creating pixel-perfect layouts",
  },
  {
    title: "Prototyping, Micro Interactions & Animation",
    description:
      "Interactive prototypes in Figma, Micro-interactions: hover states transitions feedback, Motion design basics for UI, Creating smooth clickable flows, Testing prototypes for usability",
  },
  {
    title: "UX Writing, Accessibility & User Psychology",
    description:
      "Writing clear helpful & user-friendly text, Designing accessible experiences (WCAG guidelines), Inclusive design for all types of users, Cognitive load & user psychology, Improving user experience through microcopy",
  },
  {
    title: "Usability Testing, A/B Testing & Feedback Iteration",
    description:
      "Conducting usability tests & capturing insights, A/B testing for UI improvements, Identifying friction points in user flow, Iterating designs based on data, Measuring usability with UX metrics",
  },
  {
    title: "Design Handoff, Collaboration & Product Workflow",
    description:
      "Exporting assets & creating developer-ready specs, Working with developers using Figma Inspect, Collaboration with product managers & dev teams, Agile workflows for product design, Maintaining & updating design systems",
  },
  {
    title: "Capstone UI/UX Project & Career Launchpad",
    description:
      "Complete UI/UX case study: research → design → prototype → test, Designing a full app/website with a complete user journey, Behance/Dribbble portfolio creation, Resume building & LinkedIn branding, Interview prep for UI/UX Designer Product Designer & Interaction Designer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
